<div class="modal-container">
  <div class="modal-header">
    <h2>{{ data.title }}</h2>
  </div>
  <div class="modal-content">
    <p>{{ data.message }}</p>
  </div>
  <div class="modal-actions">
    @if (cancelLabel) {
      <button mat-button type="button" (click)="close(false)">
        {{ cancelLabel }}
      </button>
    }
    <button
      mat-flat-button
      color="primary"
      type="button"
      cdkFocusInitial
      (click)="close(true)"
    >
      {{ confirmLabel }}
    </button>
  </div>
</div>
